/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React, {useState} from "react";

import GetStartedSection from "./GetStartedSection";

const GetStartedSectionContainer = () => {
  const [toggleModal, setToggleModal] = useState(false);
  return (
    <GetStartedSection
      setToggleModal={setToggleModal}
      toggleModal={toggleModal}
    />
  );
};

export default GetStartedSectionContainer;
